export const ImportSyncQueryKeys = {
  all: () => ["import-sync"],
  customers: () => [...ImportSyncQueryKeys.all(), "customers"],
  status: (customerId: string) => [...ImportSyncQueryKeys.all(), "status", customerId],
  run: (customerId: string, runId: string) => [...ImportSyncQueryKeys.all(), "run", customerId, runId],
};
